import React, { FC } from 'react'

import {
  EmptyAvatar,
  ImageHugeWithoutLink,
} from 'components/page/ForeignProfile/Photos/Photos.styled'
import { NoPhoto } from 'components/presentational/NoPhoto/NoPhoto'
import { GQLGender } from 'generated-graphql/graphql'

export const PhotoImageHugeWithoutLink: FC<{
  gender: GQLGender
  userId: string
}> = ({ gender, userId }) => (
  <ImageHugeWithoutLink>
    <EmptyAvatar data-name={`empty-photo-${gender}`}>
      <NoPhoto gender={gender} id={`empty-photo-${userId}`} />
    </EmptyAvatar>
  </ImageHugeWithoutLink>
)
